import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ChainableNumberInput } from './chainable-number-input';
import { formatRawHours } from '../helpers';
export const HoursInput = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    value,
    onChange,
    onBlur,
    period,
    use24Hours,
    ...rest
  } = _ref;
  const handleBlur = ev => {
    if (value) {
      const validHours = formatRawHours(value, use24Hours);
      const intHours = parseInt(value, 10);
      if (!use24Hours && intHours > 12) {
        onChange(validHours, intHours >= 24 ? 'AM' : 'PM');
      } else {
        onChange(validHours);
      }
    }
    onBlur == null || onBlur(ev);
  };
  const onCycle = newValue => {
    onChange(newValue, period === 'AM' ? 'PM' : 'AM');
  };
  return /*#__PURE__*/React.createElement(ChainableNumberInput, _extends({
    ref: ref,
    min: use24Hours ? 0 : 1,
    max: use24Hours ? 23 : 12,
    value: value,
    onChange: onChange,
    onCycle: onCycle,
    onBlur: handleBlur,
    "data-hook": "hours"
  }, rest));
});
HoursInput.displayName = 'HoursInput';
//# sourceMappingURL=hours-input.js.map